import toQueryString from 'src/js/common/helpers/to-query-string';
import supportedAccountTabs from '../../modules/account-management/constants/supported-tabs';

export default {
  paywall: {
    pattern: () => '/upgrade',
    url: ({ query } = {}) => `/upgrade${toQueryString(query)}`,
  },
  ecommercePaywall: {
    pattern: () => '/upgrade-ecommerce',
    url: ({ query } = {}) => `/upgrade-ecommerce${toQueryString(query)}`,
  },
  domainSelector: {
    pattern: () => '/domain-name-search',
    url: ({ query } = {}) => `/domain-name-search${toQueryString(query)}`,
  },
  dashboard: {
    pattern: () => '/dashboard',
    url: () => '/dashboard',
  },
  home: {
    pattern: () => '/',
    url: () => '/',
  },
  initiateUpgrade: {
    pattern: () => '/initiate-upgrade',
    url: ({ query } = {}) => `/initiate-upgrade${toQueryString(query)}`,
  },
  initiatePurchase: {
    pattern: () => '/initiate-purchase',
    url: ({ query } = {}) => `/initiate-purchase${toQueryString(query)}`,
  },
  accountManagement: {
    pattern: () => `/account/:tabId/*`,
    url: ({ tabId }) => `/account/${tabId}`,
  },
  billingHistory: {
    pattern: () => `:pageId?`,
    url: ({ pageId }) => `/account/${supportedAccountTabs.BILLING_HISTORY}/${pageId}`,
  },
  addPaymentMethod: {
    pattern: () => `create`,
    url: () => `/account/${supportedAccountTabs.PAYMENT_METHODS}/create`,
  },
  editPaymentMethod: {
    pattern: () => `:methodId/edit`,
    url: (methodId) => `/account/${supportedAccountTabs.PAYMENT_METHODS}/${methodId}/edit`,
  },
  deletePaymentMethod: {
    pattern: () => `:methodId/delete`,
    url: (methodId) => `/account/${supportedAccountTabs.PAYMENT_METHODS}/${methodId}/delete`,
  },
  setAsDefaultPaymentMethod: {
    pattern: () => `:methodId/set-as-default`,
    url: (methodId) =>
      `/account/${supportedAccountTabs.PAYMENT_METHODS}/${methodId}/set-as-default`,
  },
  subscriptionDetails: {
    pattern: () => '/account/subscriptions/:subId/*',
    url: ({ subId }) => `/account/subscriptions/${subId}`,
  },
  cancelSubscriptions: {
    pattern: () => '/account/subscriptions/cancel',
    url: () => '/account/subscriptions/cancel',
  },
  cancelSubscription: {
    pattern: () => '/account/subscriptions/:subId/cancel',
    url: ({ subId }) => `/account/subscriptions/${subId}/cancel`,
  },
  profile: {
    pattern: () => '/account/profile/',
    url: () => '/account/profile',
  },
  difmUpsell: {
    pattern: () => '/difm-upsell',
    url: () => '/difm-upsell',
  },
};
